import { Link, useParams, useNavigate } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';

const SaleUnitSnapSetting = () => {
  const { branchId, id } = useParams();
  const [loading, setLoading] = useState(true);
  const [snappSettings, setSnappSettings] = useState([]);
  const [unitData, setUnitData] = useState({
    id: id,
    title: "",
    description: "",
    imgSrc: "",
    logo: "",
    tels: "",
    snappSettings: [],
    branchId: branchId,
  });
  const [formModel, setFormModel] = useState([
    { Title: "کاربری اسنپ (User-id)", KeyName: "Username", SettingValue: "", IsRequired: true, DataType: 1 },
    { Title: "رمز عبور اسنپ (Password)", KeyName: "Password", SettingValue: "", IsRequired: true, DataType: 1 },
    { Title: "شناسه مشتری اسنپ (Client-id)", KeyName: "ClientId", SettingValue: "", IsRequired: true, DataType: 1 },
    { Title: "کلمه محرمانه اسنپ (Client-secret)", KeyName: "ClientSecret", SettingValue: "", IsRequired: true, DataType: 1 }
  ]);
  const navigate = useNavigate();

  // const getBaseInfo = async () => {
  //   const resp = await apiMethod.getUnitInfo(id);
  //   if (methods.showApiErrors(resp)) {
  //     const newData = resp.data;
  //     setSnappSettings(JSON.parse(newData.snappSettings) || formModel);
  //     setUnitData({ ...unitData, ...newData });
  //   }
  // };
  const getBaseInfo = async () => {
    const resp = await apiMethod.getUnitInfo(id);
    if (methods.showApiErrors(resp)) {
      const newData = resp.data;
      let snappSettingsData = newData.snappSettings ? JSON.parse(newData.snappSettings) : formModel;

      setSnappSettings(snappSettingsData);
      setUnitData({ ...unitData, ...newData });
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const editItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.createUnit({
        ...unitData,
        snappSettings: JSON.stringify(snappSettings),
      });
      if (!methods.showApiErrors(resp))
        return false;

      getBaseInfo();
      navigate(`/sale/${branchId}/saleunits`);

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const createNewItem = async (e) => {
    setLoading(true);
    try {
      const resp = await apiMethod.createUnit({
        ...unitData,
        snappSettings: JSON.stringify(formModel),
      });
      if (!methods.showApiErrors(resp))
        return false;

      getBaseInfo();
      navigate(`/sale/${branchId}/saleunits`);

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const changeSetting = (index, value, mode) => {
    const updatedSettings = mode === 'edit' ? [...snappSettings] : [...formModel];
    updatedSettings[index].SettingValue = value;
    mode === 'edit' ? setSnappSettings(updatedSettings) : setFormModel(updatedSettings);
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading />}
        {
          <>
            <div className='d-none d-lg-block'>
              <Link to={`/sale/${branchId}/saleunits`} className='text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/saleunits`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                بخش های فروش شعبه / تنظیمات اسنپ
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>بخش های فروش شعبه / تنظیمات اسنپ</p>
            </div>
            <div className="salemain">
              <div className='table-responsive saletable'>
                <form onSubmit={(e) => { e.preventDefault(); snappSettings.length > 0 ? editItem() : createNewItem(); }}>
                  <div className="row g-3">
                    {(snappSettings.length > 0 ? snappSettings : formModel).map((item, index) => (
                      <div key={index} className="col-md-4">
                        <label htmlFor={`settingValue-${index}`} className="form-label ms-2">{item.Title}</label>
                        <input
                          type="text"
                          className="form-control"
                          id={`settingValue-${index}`}
                          name={`settingValue-${index}`}
                          value={item.SettingValue}
                          onChange={(e) => changeSetting(index, e.target.value, snappSettings.length > 0 ? 'edit' : 'create')}
                        />
                      </div>
                    ))}
                    <div>
                      <button type="submit" className="btn custome-btn btn-purple float-end">
                        ثبت و ذخیره
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </>
        }
      </>
    );
  };

  return (
    <>
      {renderItems()}
    </>
  );
}

export default SaleUnitSnapSetting;